module.exports = __webpack_public_path__ + "img/testimonial-dga.513420be.png";